import { render, staticRenderFns } from "./OnlyAnonPage.vue?vue&type=template&id=0f0f1e13&"
import script from "./OnlyAnonPage.vue?vue&type=script&lang=js&"
export * from "./OnlyAnonPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports